import {
	CubeTextureLoader,
	LoopOnce,
	PMREMGenerator,
	sRGBEncoding,
	PlaneGeometry,
	ShadowMaterial,
	Mesh,
	MeshStandardMaterial,
	TextureLoader,
	MirroredRepeatWrapping,
	RepeatWrapping,
	Color
} from 'three';
import TWEEN from '@tweenjs/tween.js';
import GLTFWrapper from './GLTFWrapper';

export default class ContentController {
	constructor(scene, renderer, path) {
		const loading = 0;
		const pmremGenerator = new PMREMGenerator(renderer);
		let cubeMapTarget;

		const self = this;
		this.PATH = path;
		this.SCENE = scene;
		this.LOADING = 1;

		this.CUBE_RENDER_TARGET = null;

		this.ENVMAP = new CubeTextureLoader()
			.setPath('src/assets/cubeMaps/hafele_envmap/')
			.load(
				[
					'posx.jpg',
					'negx.jpg',
					'posy.jpg',
					'negy.jpg',
					'posz.jpg',
					'negz.jpg'
				],
				function() {
					// self.ENVMAP.encoding = sRGBEncoding;
					self.CUBE_RENDER_TARGET = pmremGenerator.fromCubemap(self.ENVMAP);
					// self.SCENE.background = self.ENVMAP;

					const meshes = self.traverseObjectForMeshes(self.SCENE);
					for (let i = 0; i < meshes.length; i++) {
						meshes[i].material.envMap = self.CUBE_RENDER_TARGET.texture;
						meshes[i].material.envMapIntensity = self.ENVMAP_INTENSITY;
						meshes[i].material.needsUpdate = true;
					}
					self.loadCompleted();
				}
			);

		this.ENVMAP_INTENSITY = 1.5;
		// Plane
		this.createShadowPlane();

		// Create store
		this.GLTF_WRAPPERS = [];
	}

	createShadowPlane() {
		const geometry = new PlaneGeometry(40, 40);
		const material = new ShadowMaterial({ opacity: 0.2 });
		this.SHADOW_PLANE = new Mesh(geometry, material);
		this.SHADOW_PLANE.rotation.set(-Math.PI / 2, 0, 0);
		this.SHADOW_PLANE.receiveShadow = true;
		this.SCENE.add(this.SHADOW_PLANE);
	}

	setConfig(config) {
		const self = this;
		const loader = new TextureLoader();
		const meshes = self.traverseObjectForNames(self.SCENE, [
			'Door_(1)',
			'oven'
		]);
		loader.load(`${this.PATH}${config.map}`, function(texture) {
			texture.wrapT = MirroredRepeatWrapping;
			texture.wrapS = RepeatWrapping;
			for (let i = 0; i < meshes.length; i++) {
				meshes[i].material.map = texture;
			}
		});
		loader.load(`${this.PATH}${config.roughnessMap}`, function(texture) {
			texture.wrapT = MirroredRepeatWrapping;
			texture.wrapS = RepeatWrapping;
			for (let i = 0; i < meshes.length; i++) {
				meshes[i].material.roughnessMap = texture;
			}
		});

		const dials = self.traverseObjectForNames(self.SCENE, ['dials']);

		dials[0].material.color = new Color(config.dialColor);

		loader.load(`${this.PATH}${config.dialMap}`, function(texture) {
			texture.wrapT = MirroredRepeatWrapping;
			texture.wrapS = RepeatWrapping;
			dials[0].material.map = texture;
			dials[0].material.needsUpdate = true;
		});
	}

	traverseObjectForVerts(object) {
		let verts = 0;

		if (object.children)
			if (object.children.length > 0)
				for (let i = 0; i < object.children.length; i++) {
					verts += this.traverseObjectForVerts(object.children[i]);
				}

		if (object.type == 'Mesh') {
			if (object.geometry.vertices) verts += object.geometry.vertices.length;
			else if (object.geometry.attributes)
				verts += object.geometry.attributes.position.array.length / 3;
		}

		return verts;
	}

	animate(intersect, animation) {
		const wrapper = this.GLTF_WRAPPERS[0];

		const door = this.traverseObjectForName(
			this.GLTF_WRAPPERS[0].GLTF.scene,
			'Door'
		);

		const tray = this.traverseObjectForName(
			this.GLTF_WRAPPERS[0].GLTF.scene,
			'trays'
		);

		// const rack1 = this.traverseObjectForName(
		// 	this.GLTF_WRAPPERS[0].GLTF.scene,
		// 	'rack_lp'
		// );

		// const rack2 = this.traverseObjectForName(
		// 	this.GLTF_WRAPPERS[0].GLTF.scene,
		// 	'rack-2_lp'
		// );

		if (animation == 'open') {
			intersect.object.animation = 'close';
			new TWEEN.Tween(door.rotation)
				.easing(TWEEN.Easing.Quadratic.InOut)
				.to({ x: 1.5707967986146556 }, 500)
				.start();
			new TWEEN.Tween(tray.position)
				.easing(TWEEN.Easing.Quadratic.InOut)
				.to({ z: 0.3 }, 800)
				.start();
			// new TWEEN.Tween(rack1.position)
			// 	.easing(TWEEN.Easing.Quadratic.InOut)
			// 	.to({ z: 0.2 }, 1000)
			// 	.start();
			// new TWEEN.Tween(rack2.position)
			// 	.easing(TWEEN.Easing.Quadratic.InOut)
			// 	.to({ z: 0.3 }, 800)
			// 	.start();
			// wrapper.ANIMATION_ACTIONS.forEach(actionIn => {
			// 	const ACTION = actionIn;
			// 	ACTION.loop = LoopOnce;
			// 	ACTION.reset();
			// 	ACTION.play();
			// 	setTimeout(function() {
			// 		ACTION.paused = true;
			// 	}, 2700);
			// });
		} else if (animation == 'close') {
			intersect.object.animation = 'open';
			new TWEEN.Tween(tray.position)
				.easing(TWEEN.Easing.Quadratic.InOut)
				.to({ z: 0 }, 500)
				.start();
			// new TWEEN.Tween(rack1.position)
			// 	.easing(TWEEN.Easing.Quadratic.InOut)
			// 	.to({ z: 0 }, 500)
			// 	.start();
			// new TWEEN.Tween(rack2.position)
			// 	.easing(TWEEN.Easing.Quadratic.InOut)
			// 	.to({ z: 0 }, 800)
			// 	.start();
			new TWEEN.Tween(door.rotation)
				.easing(TWEEN.Easing.Quadratic.InOut)
				.to({ x: 0 }, 800)
				.start();
			// wrapper.ANIMATION_ACTIONS.forEach(actionIn => {
			// 	const ACTION = actionIn;
			// 	ACTION.paused = false;
			// });
		}
	}

	traverseObjectForName(object, name) {
		let found = null;

		if (object.children)
			if (object.children.length > 0)
				for (let i = 0; i < object.children.length; i++) {
					found = this.traverseObjectForName(object.children[i], name);
					if (found) return found;
				}

		if (object.name == name) return object;

		return undefined;
	}

	traverseObjectForNames(object, names) {
		let objects = [];

		if (object.children)
			if (object.children.length > 0)
				for (let i = 0; i < object.children.length; i++) {
					objects = objects.concat(
						this.traverseObjectForNames(object.children[i], names)
					);
				}

		for (let i = 0; i < names.length; i++) {
			if (object.name == names[i]) {
				objects.push(object);
				break;
			}
		}

		return objects;
	}

	addGLTF(model, loaded) {
		this.loaded = loaded;
		const GLTF_WRAPPER = new GLTFWrapper(
			this.PATH + model,
			this.GLTF_WRAPPERS.length,
			this.onGLTFLoaded.bind(this),
			this.onGLTFError.bind(this)
		);

		// Store
		this.GLTF_WRAPPERS.push(GLTF_WRAPPER);

		this.traverseObjectForVerts(GLTF_WRAPPER);
		this.LOADING++;
	}

	onGLTFLoaded(wrapperId) {
		this.GLTF_WRAPPERS[wrapperId].animationInitialise();
		this.GLTF_WRAPPERS[wrapperId].addTo(this.SCENE);
		if (this.loaded) this.loaded(this.GLTF_WRAPPERS[wrapperId]);
		const meshes = this.traverseObjectForMeshes(
			this.GLTF_WRAPPERS[wrapperId].GLTF_SCENE
		);

		for (let i = 0; i < meshes.length; i++) {
			meshes[i].castShadow = true;
			meshes[i].recieveShadow = true;
			// if (meshes[i].material.roughnessMap) {
			// 	meshes[i].material.roughnessMap.mipMaps = [];
			// 	meshes[i].material.roughnessMap.generateMipmaps = false;
			// }
			if (this.CUBE_RENDER_TARGET != undefined) {
				meshes[i].material.envMap = this.CUBE_RENDER_TARGET.texture;
				meshes[i].material.envMapIntensity = this.ENVMAP_INTENSITY;
				meshes[i].material.needsUpdate = true;
			}
		}
		this.loadCompleted();
	}

	loadCompleted() {
		this.LOADING--;
		if (this.LOADING == 0 && this.loadingCompleted) {
			this.loadingCompleted();
		}
	}

	onGLTFError(error) {
		console.log('ContentController. onGLTFError');
		console.log(error);
	}

	tick(time) {
		for (let i = 0; i < this.GLTF_WRAPPERS.length; i++) {
			this.GLTF_WRAPPERS[i].animationUpdate(time);
		}
	}

	setWireframeOn() {
		const { GLTF_WRAPPERS } = this;

		for (let i = 0; i < GLTF_WRAPPERS.length; i += 1) {
			GLTF_WRAPPERS[i].wireframeSet(true);
		}

		this.isWireframe = true;
	}

	setWireframeOff() {
		const { GLTF_WRAPPERS } = this;

		for (let i = 0; i < GLTF_WRAPPERS.length; i += 1) {
			GLTF_WRAPPERS[i].wireframeSet(false);
		}

		this.isWireframe = false;
	}

	traverseObjectForMeshes(object) {
		let meshes = [];

		if (object.children)
			if (object.children.length > 0)
				for (let i = 0; i < object.children.length; i++) {
					meshes = meshes.concat(
						this.traverseObjectForMeshes(object.children[i])
					);
				}

		if (object.geometry) meshes.push(object);

		return meshes;
	}
}
